class VideoBlock extends HTMLElement {
    constructor() {
      super();
      this.videoEl = this.querySelector('video');
      this.controlsOverlay = this.querySelector('.video-overlay-with-btn');
      this.playing = false;
      this.muted = true;
      this.playBtn = this.querySelector('button.play-btn');
      this.pauseBtn = this.querySelector('button.pause-btn');
      this.audioBtn = this.querySelector('button.mute-unmute-btn');
      this.allVideos = document.querySelectorAll('video-block');
    }

    connectedCallback() {
      this.videoEl.play();
      setTimeout(() => {
        this.videoEl.pause();
      },500);
      this.playBtn.addEventListener('click', this.playPauseVideo.bind(this));
      this.pauseBtn.addEventListener('click', this.playPauseVideo.bind(this));
      this.audioBtn?.addEventListener('click', this.muteUnmuteVideo.bind(this));
    }

    disconnectedCallback() {
      this.playBtn.removeEventListener('click', this.playPauseVideo);
      this.pauseBtn.removeEventListener('click', this.playPauseVideo);
      this.audioBtn?.removeEventListener('click', this.muteUnmuteVideo);
    }

    pauseVideo() {
      this.playing = false;
      this.videoEl.pause()
      this.controlsOverlay.classList.remove('playing');
      this.controlsOverlay.classList.add('paused');
    }

    playPauseVideo() {
      if(this.playing) {
        this.pauseVideo();
      }
      else {
        this.allVideos.forEach(videoBlock => {
          videoBlock.pauseVideo();
          videoBlock.playing = false;
          videoBlock.controlsOverlay.classList.remove('playing');
          videoBlock.controlsOverlay.classList.add('paused');
        });
        this.playing = true;
        this.videoEl.play();
        this.controlsOverlay.classList.add('playing');
        this.controlsOverlay.classList.remove('paused');
      }
    }

    muteUnmuteVideo() {
      if(this.muted) {
        this.muted = false;
        this.videoEl.muted = false;
        this.audioBtn.classList.remove('muted');
        this.audioBtn.classList.add('unmuted');
      }
      else {
        this.muted = true;
        this.videoEl.muted = true;
        this.audioBtn.classList.remove('unmuted');
        this.audioBtn.classList.add('muted');
      }
    }

  }
  if (!window.customElements.get("video-block")) {
    window.customElements.define("video-block", VideoBlock);
  }